import { PouchDB, _ } from '../lib';
export class EncryptedCache {
    db;
    data;
    __name;
    __key;
    async connect(obj) {
        this.__name = obj?.name ?? this.__name;
        this.__key = obj?.key ?? this.__key;
        if (!this.__name) {
            throw new Error('No name given when connecting to EncryptedCache');
        }
        await this.close();
        this.db = new PouchDB(this.__name);
        await this.db.crypto(this.__key);
        this.data = {};
        await this.__read('index__');
    }
    async __read(key) {
        let data;
        if (this.db == null || !this.data) {
            throw new Error('Database not connected');
        }
        try {
            data = await this.db.get(key);
        }
        catch (err) {
            if (err instanceof Error && err.name === 'not_found') {
                return null;
            }
            console.error(err);
            throw new Error('Error reading local cache data model');
        }
        this.data[key] = data.value;
        return data;
    }
    async read(keys) {
        if (typeof keys === 'string') {
            keys = [keys];
        }
        return Promise.all(keys.map(async (key) => {
            const response = await this.__read(key);
            return response?.value;
        }));
    }
    async readAll() {
        if (this.db == null) {
            throw new Error('Database not connected');
        }
        const docs = await this.db.allDocs();
        const keys = docs.rows.map(x => x.id);
        const values = await this.read(keys);
        return _.fromPairs(_.zip(keys, values));
    }
    async write(key, data) {
        if (!this.db || !this.data) {
            throw new Error('Database not connected');
        }
        const rev = (await this.__read(key)) ?? { _rev: '1-' };
        const record = {
            _id: key,
            _rev: String(1 + Number(rev._rev.split('-')?.[0] ?? 0)),
            value: data,
        };
        const resp = await this.db.put(record, { force: true });
        this.data[key] = data;
        if (key !== 'index__') {
            const index = (this.data['index__'] ?? {});
            index[key] = null;
            await this.write('index__', index);
        }
        return resp;
    }
    async close() {
        if (this.db == null) {
            return;
        }
        await this.db.close();
    }
    async destroy() {
        this.data = null;
        if (this.db == null) {
            return;
        }
        await this.db.removeCrypto();
        await this.db.destroy();
        this.db = null;
    }
    async reset() {
        await this.destroy();
        await this.connect();
    }
}
//# sourceMappingURL=component-local-cache.js.map